module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<tr v-bind:id='rowId'>\n  <td>\n    <a v-if='row.order_document_url' v-bind:href='row.order_document_url' target='_blank'>\n      {{ t('admin.report_rows.index.go_to_document') }}\n    </a>\n  </td>\n  <td>{{row.agreement_number}}</td>\n  <td>{{row.employee_name}}</td>\n  <td>{{row.position}}</td>\n  <td>{{row.budget_numbers}}</td>\n  <td>{{row.budget_codes}}</td>\n  <td>{{row.salary}}</td>\n  <td>{{row.intensity}}</td>\n  <td>{{row.start_date}}</td>\n  <td>{{row.end_date}}</td>\n  <td>{{row.notes}}</td>\n  <td>{{row.client_notes}}</td>\n  <td class='actions'>\n    <button class='btn btn-sm btn-danger' type='button' v-on:click='destroyInvolvedEmployeeRow'>\n      <i class='fa fa-trash'></i>\n    </button>\n  </td>\n</tr>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
